import { SET_KEYBOXES } from '../constants/KeyboxConstants';

const initialState = {
  keyboxes: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_KEYBOXES: {
      return {
        ...state,
        keyboxes: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
